import React from 'react';
import ChevronDownFilled from '@uber/base-icons/chevron-down-filled';
import ChevronRightFilled from '@uber/base-icons/chevron-right-filled';
import { useStyletron } from 'baseui';
import { getChevronSlotStyle } from './styles';
type PropsT = {
  expanded: boolean;
  onToggle: () => void;
};
export const ExpandChevron = ({
  expanded,
  onToggle
}: PropsT) => {
  const [css, theme] = useStyletron();
  const Icon = expanded ? ChevronDownFilled : ChevronRightFilled;
  return <button type="button" data-testid="row-label-chevron" aria-label={expanded ? 'Collapse attributes' : 'Expand attributes'} aria-expanded={expanded} className={css({
    ...getChevronSlotStyle(theme),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    color: theme.colors.contentSecondary
  })} onClick={onToggle}>
      <Icon size={theme.sizing.scale600} />
    </button>;
};